export const getRedemptionErrorToastMsg = () =>
  "There was an error while preparing download. Please try again.";

export const getRedemptionSuccessToastMsg = (expiration?: string) =>
  `Successfully prepared download. Please check your email. Your download link will expire after ${
    expiration ?? "1 hour"
  }`;
